import React, { useState } from 'react'
import PropTypes from 'prop-types'
import DatePicker from 'react-datepicker'
import InputDateRange from './inputDateRange'
import styles from './styles.dateRange.module.scss'
import 'react-datepicker/dist/react-datepicker.css'
import clsx from 'clsx'

const DateRange = (props) => {
  const {
    classNameInput = '',
    isClearable = false,
    dateFormat = 'MM/DD/YYYY',
    isError = false,
    onChange: onChangeDateRange = () => {},
  } = props
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const onChange = (dates) => {
    const [start, end] = dates
    setStartDate(start)
    setEndDate(end)

    if (onChangeDateRange) {
      onChangeDateRange({ start, end })
    }
  }

  return (
    <div className={clsx(styles.dateRangeAic, isError && styles.dateRangeError)}>
      <DatePicker
        selectsRange
        dateFormat="MM/dd/YYY"
        minDate={new Date()}
        startDate={startDate}
        endDate={endDate}
        onChange={onChange}
        isClearable={isClearable}
        customInput={
          <InputDateRange
            dateFormat={dateFormat}
            isClearable={isClearable}
            className={classNameInput}
          />
        }
      />
    </div>
  )
}

DateRange.propTypes = {
  classNameInput: PropTypes.string,
  isClearable: PropTypes.bool,
  isError: PropTypes.bool,
  onChange: PropTypes.func,
  dateFormat: PropTypes.string,
}

export default DateRange
